package ar.corzo.health_tracker.types

import ar.corzo.health_tracker.utils.dateFormatNoPad
import ar.corzo.health_tracker.utils.getDouble
import ar.corzo.health_tracker.utils.getString
import ar.corzo.health_tracker.utils.log
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.minus
import kotlinx.datetime.toLocalDateTime

data class Account(
    override val id: String,
    val name: String?,
    val birth: LocalDate?,
    val weight: Double?
):ObjectUUID{
    val firstName = name?.split(" ")?.firstOrNull()?:name

    companion object{
        fun from(raw: Map<String, *>, id: String): Account?{
            log(raw)
            val name = raw.getString("name")?.trimIndent()?.lines()?.firstOrNull()?.takeIf { it.isNotBlank() }
            log("$name ${raw.getString("name")}")

            val birth = raw.getString("birth")?.let{
                runCatching {
                    LocalDate.parse(it, dateFormatNoPad)
                }.getOrNull()
            }

            val weight = raw.getDouble("weight")?.takeIf { it > 0 }

            return Account(id, name, birth, weight)
        }
    }
    fun age(now: Instant = Clock.System.now(), zone: TimeZone = TimeZone.currentSystemDefault()) = if(birth!=null) now.toLocalDateTime(zone).date.minus(birth).years else null
}